import { Constants } from "./../../_helpers/constants-handle";
import { Component, OnInit, OnDestroy, Renderer2 } from "@angular/core";
import {
  DrawService,
  AlertService,
  CommonService,
  AuthenticationService,
  ToastService,
} from "../../_services";
import { filter, delay, first } from "rxjs/operators";
import { Router, ActivationEnd } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { CurrencySymbolPipe, CustomCurrencyPipe } from "src/app/_directives";

@Component({
  selector: ".game-zone",
  templateUrl: "./thai-lottery.component.html",
})
export class ThaiLotteryComponent implements OnInit, OnDestroy {
  gameCode = Constants.THAI_LOTTERY;
  currentEnterNumIndex = 0;
  panelCounter = 1;
  panelNumberCounter;
  gameData: any;
  userData: any;
  numberArray = [];
  gameDataSubscription: any;
  rootData: any;
  betAmtArray = [];
  otherAmtVal = "";
  showOtherAmountInput = false;
  betData = {};
  otherBetAmountMultiple = 0;
  betError = "";
  userInfo: any;
  timeIntervalContainer: any;
  tempCounter = 0;
  fetchDataStatus = false;
  diff_time: any;
  resetPlaySubscription: any;
  mainBetSection: any;
  rangeNumber: any;
  permInput = "";
  showNumGroupList = true;
  showNumSelectionWrap = true;
  permClicked = false;
  postState = true;
  postStateMsg = "";
  userInfoLocalSubscription: any;
  notifyDrawMachineSubscription: any;
  authenticationSubscription: any;
  routeSubscription: any;
  postStateInterval: any;
  gameFetchCounter = 0;
  loadLobby = true;
  myTicketCount = 0;
  ticketListSubscription: any;
  notifyTktLstSubscription: any;
  gameSchemas = [];
  clientCode = Constants.CLIENT_CODE;
  otherNotice = "";
  saleTimerStatus = false;
  payoutWiseNumbersData = {};
  activeDrawStatus = true;

  constructor(
    private drawService: DrawService,
    private alertService: AlertService,
    private renderer: Renderer2,
    private commonService: CommonService,
    private authenticationService: AuthenticationService,
    private translate: TranslateService,
    private router: Router,
    private currSymbol: CurrencySymbolPipe,
    private currCustom: CustomCurrencyPipe,
    private toastService: ToastService
  ) {
    this.rootData = Constants.GAME_DATA[Constants.DRAW_ENGINE][this.gameCode];
    this.routeSubscription = router.events
      .pipe(
        filter((e) => e instanceof ActivationEnd),
        first()
      )
      .subscribe((val) => {
        let tempVar = <any>val;
        let params = tempVar.snapshot.params;
        if (
          typeof params.playerid != "undefined" &&
          typeof params.playername != "undefined" &&
          typeof params.sessid != "undefined" &&
          typeof params.bal != "undefined" &&
          typeof params.lang != "undefined" &&
          typeof params.curr != "undefined" &&
          typeof params.alias != "undefined" &&
          typeof params.isMobileApp != "undefined"
        ) {
          this.loadLobby = false;
        }
        if(params.isMobileApp == 0) {
          this.loadLobby = true;
        }
        this.commonService.iframe_resize();
      });
  }

  ngOnInit() {
    this.commonService.addEngineClass();
    if (window.innerWidth >= Constants.TAB_WIDTH) {
      this.addMainbetPanel();
    }
    this.gameDataSubscription = this.drawService
      .subscribeGameData()
      .pipe(
        delay(0),
        filter(
          (response) =>
            response != null &&
            typeof response.data.responseData.gameRespVOs[0].numberConfig !=
              "undefined"
        )
      )
      .subscribe((response: any) => {
        response.data.responseData.gameRespVOs.forEach((element) => {
          if (element.gameCode == this.gameCode) {
            this.gameData = element;
            if (this.gameFetchCounter == 0) {
              if (
                response.timerType == this.gameCode ||
                response.timerType == ""
              ) {
                this.resetUserData();
              }
              if (window.innerWidth >= Constants.TAB_WIDTH) {
                this.addMainbetPanel();
              } else {
                this.removeBetPanels();
              }
            }
            this.betAmtArray = [];
            for (let i = 0; i < element.betRespVOs.length; i++) {
              this.betData[element.betRespVOs[i].betCode] = JSON.parse(
                JSON.stringify(element.betRespVOs[i])
              );
              let tempVar = {};
              for (
                let j = 0;
                j <
                this.betData[element.betRespVOs[i].betCode].pickTypeData
                  .pickType.length;
                j++
              ) {
                tempVar[element.betRespVOs[i].pickTypeData.pickType[j].code] =
                  this.betData[
                    element.betRespVOs[i].betCode
                  ].pickTypeData.pickType[j];
              }
              this.betData[
                element.betRespVOs[i].betCode
              ].pickTypeData.pickType = tempVar;
            }
            let betArrayLength = Math.floor(element.betRespVOs[0].maxBetAmtMul);
            betArrayLength = betArrayLength > 8 ? 9 : betArrayLength;
            //if (element.betRespVOs[0].unitPrice <= 1) {
            if (element.betRespVOs[0].unitPrice < 1) {
              for (let i = 1; i <= betArrayLength; i++) {
                if (
                  element.betRespVOs[0].unitPrice * i * 10 <=
                  element.betRespVOs[0].maxBetAmtMul *
                    element.betRespVOs[0].unitPrice
                ) {
                  this.betAmtArray.push(
                    element.betRespVOs[0].unitPrice * i * 10
                  );
                }
              }
            } else {
              for (let i = 1; i <= betArrayLength; i++) {
                if (
                  element.betRespVOs[0].unitPrice * i <=
                  element.betRespVOs[0].maxBetAmtMul *
                    element.betRespVOs[0].unitPrice
                ) {
                  this.betAmtArray.push(element.betRespVOs[0].unitPrice * i);
                }
              }
            }
            this.gameSchemas = [];
            if (typeof element.gameSchemas != "undefined") {
              for (let i = 0; i < element.gameSchemas.matchDetail.length; i++) {
                this.gameSchemas[element.gameSchemas.matchDetail[i].betType] =
                  JSON.parse(
                    JSON.stringify(element.gameSchemas.matchDetail[i])
                  );
              }
            }
            if (
              typeof element.payoutWiseNumbersData != "undefined" &&
              element.drawRespVOs.length != 0 &&
              element.payoutWiseNumbersData[0].drawId ==
                element.drawRespVOs[0].drawId
            ) {
              for (
                let i = 0;
                i < element.payoutWiseNumbersData[0].betWise.length;
                i++
              ) {
                let tempNumArray = [];
                let tempColorArray = [];
                for (
                  let j = 0;
                  j < element.payoutWiseNumbersData[0].betWise[i].slabs.length;
                  j++
                ) {
                  tempNumArray = [
                    ...tempNumArray,
                    ...element.payoutWiseNumbersData[0].betWise[i].slabs[j]
                      .numbers,
                  ];
                  for (
                    let k = 0;
                    k <
                    element.payoutWiseNumbersData[0].betWise[i].slabs[j].numbers
                      .length;
                    k++
                  ) {
                    tempColorArray.push({
                      number:
                        element.payoutWiseNumbersData[0].betWise[i].slabs[j]
                          .numbers[k],
                      slab: element.payoutWiseNumbersData[0].betWise[i].slabs[j]
                        .slabPrizeValue,
                      color: (() => {
                        if (
                          this.gameSchemas[
                            element.payoutWiseNumbersData[0].betWise[i].betCode
                          ]
                        ) {
                          for (
                            let x = 0;
                            x <
                            this.gameSchemas[
                              element.payoutWiseNumbersData[0].betWise[i]
                                .betCode
                            ].slabInfo.length;
                            x++
                          ) {
                            // if (parseFloat(element.payoutWiseNumbersData[0].betWise[i].slabs[j].slabPrizeValue) <= parseFloat(this.gameSchemas[element.payoutWiseNumbersData[0].betWise[i].betCode].slabInfo[x].endRange)) {
                            if (
                              parseFloat(
                                element.payoutWiseNumbersData[0].betWise[i]
                                  .slabs[j].slabPrizeValue
                              ) ==
                              parseFloat(
                                this.gameSchemas[
                                  element.payoutWiseNumbersData[0].betWise[i]
                                    .betCode
                                ].slabInfo[x].slabPrizeValue
                              )
                            ) {
                              return x + 1;
                            }
                          }
                          return 0;
                        } else {
                          return 0;
                        }
                      })(),
                    });
                  }
                }
                this.payoutWiseNumbersData[
                  element.payoutWiseNumbersData[0].betWise[i].betCode
                ] = {
                  numbers: tempNumArray,
                  colorData: tempColorArray,
                };
              }
            }
            this.fetchDataStatus = true;
            this.tempCounter = 0;
            clearInterval(this.timeIntervalContainer);
            if (
              response.timerType == element.gameCode ||
              response.timerType == ""
            ) {
              let tempTime = 0;
              let tempTime2 = 0;
              let fetchRuleStatus = false;
              if (element.drawRespVOs.length != 0) {
                this.activeDrawStatus = true;
                this.renderer.removeClass(document.body, "modal-fix");
                // tempTime = Math.floor((new Date(element.timeToFetchUpdatedGameInfo.replace(/-/g, "/")).getTime() - new Date().getTime()) / 1000);
                tempTime = Math.floor(
                  (new Date(
                    this.drawService.changeDateFormat(
                      element.timeToFetchUpdatedGameInfo
                    )
                  ).getTime() -
                    DrawService.gameTime) /
                    1000
                );
                if (
                  typeof element.drawRespVOs[0].drawSaleStartTime != "undefined"
                ) {
                  tempTime2 = Math.floor(
                    (new Date(
                      this.drawService.changeDateFormat(
                        element.drawRespVOs[0].drawSaleStartTime
                      )
                    ).getTime() -
                      DrawService.gameTime) /
                      1000
                  );
                }
              } else {
                this.activeDrawStatus = false;
                this.renderer.addClass(document.body, "modal-fix");
              }
              this.diff_time = {
                totalTime: tempTime >= 0 ? tempTime : 0,
                shownTime: ["00", "00", "00", "00"],
                convention: "sec",
                saleStartTime: tempTime2 >= 0 ? tempTime2 : 0,
                saleShownTime: ["00", "00", "00", "00"],
                saleConvention: "sec",
                fetchRuleStatus: fetchRuleStatus,
              };
            }
            ++this.gameFetchCounter;
          }
        });
        this.fetchPlayerTicketList();
        this.updateClock();
        this.timeIntervalContainer = setInterval(() => {
          this.updateClock();
        }, 1000);
        this.commonService.iframe_resize();
      });
    this.resetPlaySubscription = this.drawService
      .subscribeResetPlayUserData()
      .subscribe((response) => {
        if (response.status) {
          this.resetUserData();
        }
        this.commonService.iframe_resize();
      });
    this.userInfoLocalSubscription = this.authenticationService
      .subscribeuserInfoLocal()
      .subscribe((response) => {
        this.userInfo = response;
        this.commonService.iframe_resize();
      });
    this.notifyTktLstSubscription = this.drawService
      .subscribeTicketList()
      .subscribe((response) => {
        this.fetchPlayerTicketList();
      });
  }

  ngOnDestroy(): void {
    this.removeBetPanels();
    this.commonService.closeAllModals();
    this.renderer.removeClass(document.body, "modal-open");
    this.renderer.removeClass(document.body, "modal-fix");
    clearInterval(this.timeIntervalContainer);
    clearInterval(this.postStateInterval);
    if (typeof this.gameDataSubscription != "undefined") {
      this.gameDataSubscription.unsubscribe();
    }
    if (typeof this.resetPlaySubscription != "undefined") {
      this.resetPlaySubscription.unsubscribe();
    }
    if (typeof this.userInfoLocalSubscription != "undefined") {
      this.userInfoLocalSubscription.unsubscribe();
    }
    if (typeof this.routeSubscription != "undefined") {
      this.routeSubscription.unsubscribe();
    }
    if (typeof this.authenticationSubscription != "undefined") {
      this.authenticationSubscription.unsubscribe();
    }
    if (typeof this.notifyDrawMachineSubscription != "undefined") {
      this.notifyDrawMachineSubscription.unsubscribe();
    }
    if (typeof this.ticketListSubscription != "undefined") {
      this.ticketListSubscription.unsubscribe();
    }
    if (typeof this.notifyTktLstSubscription != "undefined") {
      this.notifyTktLstSubscription.unsubscribe();
    }
    this.commonService.iframe_resize();
  }

  loadBackPanel() {
    this.removeBetPanels();
    this.resetUserData();
    this.commonService.iframe_resize();
  }

  addMainbetPanel() {
    this.renderer.addClass(
      document.getElementsByClassName("bodyWrapper")[0],
      "vi-mainbet"
    );
    this.renderer.removeClass(
      document.getElementsByClassName("bodyWrapper")[0],
      "vi-confirm"
    );
    this.renderer.removeClass(
      document.getElementsByClassName("bodyWrapper")[0],
      "vi-sidebet"
    );
    this.commonService.iframe_resize();
  }

  removeBetPanels() {
    this.renderer.removeClass(
      document.getElementsByClassName("bodyWrapper")[0],
      "vi-mainbet"
    );
    this.renderer.removeClass(
      document.getElementsByClassName("bodyWrapper")[0],
      "vi-confirm"
    );
    this.renderer.removeClass(
      document.getElementsByClassName("bodyWrapper")[0],
      "vi-sidebet"
    );
    this.commonService.iframe_resize();
  }

  resetUserData() {
    if (
      (window.innerWidth >= Constants.TAB_WIDTH &&
        !document
          .getElementsByClassName("bodyWrapper")[0]
          .classList.contains("vi-sidebet")) ||
      document
        .getElementsByClassName("bodyWrapper")[0]
        .classList.contains("vi-mainbet")
    ) {
      this.userData = {
        panelData: [
          {
            betType: this.gameData.betRespVOs[0].betCode,
            pickType: this.gameData.betRespVOs[0].pickTypeData.pickType[0].code,
            pickConfig: this.gameData.betRespVOs[0].pickTypeData.pickType[0].range[0].pickConfig,
            betAmountMultiple:(this.gameData.betRespVOs[0].unitPrice < 1) ? (this.gameData.betRespVOs[0].unitPrice * this.gameData.betRespVOs[0].maxBetAmtMul) : 1,
            quickPick: false,
            pickedValues: Array(+this.gameData.maxPanelAllowed),
            qpPreGenerated: false,
            totalNumbers:
              this.gameData.betRespVOs[0].betGroup == "3Digit"
                ? 3
                : this.gameData.betRespVOs[0].betGroup == "2Digit"
                ? 2
                : 1,
            currentPayout: 0,
          },
        ],
      };
      this.panelNumberCounter = +this.gameData.maxPanelAllowed;
      this.mainBetSection =
        (this.gameData.betRespVOs[0].betGroup == "3Digit"
          ? 3
          : this.gameData.betRespVOs[0].betGroup == "2Digit"
          ? 2
          : 1) + "digit";
      this.numberArray = [];
      if (this.gameData.betRespVOs[0].betCode.slice(-1) == 3) {
        for (let i = 0; i <= 999; i++) {
          this.numberArray.push(("000" + i).substr(-3));
        }
        this.showNumGroupList = true;
      }
      if (this.gameData.betRespVOs[0].betCode.slice(-1) == 2) {
        for (let i = 0; i <= 99; i++) {
          this.numberArray.push(("00" + i).substr(-2));
        }
        this.showNumGroupList = false;
      }
      if (this.gameData.betRespVOs[0].betCode.slice(-1) == 1) {
        for (let i = 0; i <= 9; i++) {
          this.numberArray.push(("0" + i).substr(-1));
        }
        this.showNumGroupList = false;
      }
      this.rangeNumber = 0;
      this.postStateMsg = this.translate.instant(
        "dge." +
          this.gameData.betRespVOs[0].betCode +
          "_" +
          this.gameData.betRespVOs[0].pickTypeData.pickType[0].code +
          "_desc"
      );
    } else {
      this.userData = {
        panelData: [
          {
            betType: "",
            pickType: "",
            pickConfig: "",
            betAmountMultiple: (this.gameData.betRespVOs[0].unitPrice < 1) ? (this.gameData.betRespVOs[0].unitPrice * this.gameData.betRespVOs[0].maxBetAmtMul) : 1,
            quickPick: false,
            pickedValues: [],
            qpPreGenerated: false,
            totalNumbers: 0,
            currentPayout: 0,
          },
        ],
      };
      this.panelNumberCounter = 0;
      this.rangeNumber = 0;
      this.numberArray = [];
      this.postStateMsg = "";
    }
    this.currentEnterNumIndex = 0;
    this.otherAmtVal = "";
    this.showOtherAmountInput = false;
    this.panelCounter = 1;
    this.permInput = "";
    this.permClicked = false;
    this.showNumGroupList = true;
    this.commonService.iframe_resize();
  }

  onPermInputChange() {
    let regex = /[^0-9]/g;
    const initalValue = this.permInput;
    this.permInput = initalValue.replace(regex, "").substr(0, 3);
    if (this.permInput == "") {
      this.showNumGroupList = true;
      this.showNumSelectionWrap = true;
    }
    // else if (this.permInput.length < 3) {
    //   this.showNumGroupList = false;
    //   this.showNumSelectionWrap = false;
    // }
    else {
      this.showNumGroupList = false;
      this.showNumSelectionWrap = true;
    }
    this.permClicked = false;
  }

  arrayNormalRange(n) {
    return Array(Math.ceil(n / 100));
    this.commonService.iframe_resize();
  }

  getNumberArray() {
    let regex = /[^0-9]/g;
    let returnValue = [];
    if (regex.test(this.permInput) || this.permInput.length > 3) {
      returnValue = [];
    } else if (this.permInput.length == 3 && this.permClicked == false) {
      returnValue = [this.permInput];
    } else if (this.permInput.length == 3 && this.permClicked == true) {
      returnValue = this.permute(this.permInput, 0, 2);
    } else if (
      this.permInput.length > 0 &&
      this.permInput.length < 3 &&
      this.permClicked == false
    ) {
      returnValue = [("000" + this.permInput).substr(-3)];
    } else if (
      this.permInput.length > 0 &&
      this.permInput.length < 3 &&
      this.permClicked == true
    ) {
      returnValue = this.permute(("000" + this.permInput).substr(-3), 0, 2);
    } else {
      returnValue = this.numberArray.slice(
        this.rangeNumber * 100,
        (this.rangeNumber + 1) * 100
      );
    }
    // if (typeof this.gameData != 'undefined' && typeof this.gameData.betWiseDisabledNumbers != 'undefined') {
    //   let filterArray = (this.gameData.betWiseDisabledNumbers.filter((e) => e.betCode == this.userData.panelData[this.panelCounter - 1].betType))[0].disabledNumbers;
    //   returnValue = returnValue.filter((e) => !(filterArray.indexOf(e) > -1));
    // }
    return returnValue;
    this.commonService.iframe_resize();
  }

  checkNumberDisabled(num) {
    let filterArray = this.getFilterArray();
    return filterArray.indexOf(num) > -1;
  }

  needSuggestion(num) {
    let filterArray = this.getFilterArray();
    if (filterArray.indexOf(num) > -1) {
      let returnValue = this.numberArray.slice(
        this.rangeNumber * 100,
        (this.rangeNumber + 1) * 100
      );
      returnValue = returnValue.filter((e) => !(filterArray.indexOf(e) > -1));
      return returnValue[Math.floor(Math.random() * returnValue.length)];
    }
    return false;
  }

  getFilterArray() {
    if (
      typeof this.gameData != "undefined" &&
      typeof this.gameData.disabledNumberData != "undefined"
    ) {
      let filterArray = [];
      for (let i = 0; i < this.gameData.disabledNumberData.length; i++) {
        if (
          this.gameData.disabledNumberData[i].drawId ==
          this.gameData.drawRespVOs[0].drawId
        ) {
          let tempfilterObjectArray = this.gameData.disabledNumberData[
            i
          ].betWiseDisabledNumbers.filter((e) => {
            return (
              e.betCode ==
              this.userData.panelData[this.panelCounter - 1].betType
            );
          });
          if (tempfilterObjectArray.length > 0) {
            filterArray = [
              ...filterArray,
              ...tempfilterObjectArray[0].disabledNumbers,
            ];
          }
        }
      }
      return filterArray;
    }
    return [];
  }

  permute(str, l, r) {
    let tempArr = [];
    if (l == r) {
      return str;
    } else {
      for (let i = l; i <= r; i++) {
        str = this.swap(str, l, i);
        let a = this.permute(str, l + 1, r);
        if (Array.isArray(a)) {
          for (let t = 0; t < a.length; t++) {
            if (tempArr.indexOf(a[t]) < 0) {
              tempArr.push(a[t]);
            }
          }
        } else {
          if (tempArr.indexOf(a) < 0) {
            tempArr.push(a);
          }
        }
        str = this.swap(str, l, i);
      }
    }
    return tempArr;
  }

  swap(str, i, j) {
    let temp;
    let charArray = str.split("");
    temp = charArray[i];
    charArray[i] = charArray[j];
    charArray[j] = temp;
    return charArray.join("");
  }

  rangeSelect(i) {
    this.rangeNumber = i;
  }

  selectGamePick(mainBetSection, betCode, pickCode, index) {
    this.addMainbetPanel();
    this.mainBetSection = mainBetSection;
    if (
      this.userData.panelData[this.panelCounter - 1].betType != betCode ||
      this.userData.panelData[this.panelCounter - 1].pickType != pickCode
    ) {
      if (this.userData.panelData[this.panelCounter - 1].betType != betCode) {
        this.numberArray = [];
        if (betCode.slice(-1) == 3) {
          for (let i = 0; i <= 999; i++) {
            this.numberArray.push(("000" + i).substr(-3));
          }
          this.showNumGroupList = true;
        }
        if (betCode.slice(-1) == 2) {
          for (let i = 0; i <= 99; i++) {
            this.numberArray.push(("00" + i).substr(-2));
          }
          this.showNumGroupList = false;
        }
        if (betCode.slice(-1) == 1) {
          for (let i = 0; i <= 9; i++) {
            this.numberArray.push(("0" + i).substr(-1));
          }
          this.showNumGroupList = false;
        }
      }
      this.gameData.betRespVOs.forEach((element) => {
        if (betCode == element.betCode) {
          this.userData.panelData[this.panelCounter - 1].betType =
            element.betCode;
          element.pickTypeData.pickType.forEach((pickElement) => {
            if (pickCode == pickElement.code) {
              this.rangeNumber = 0;
              this.userData.panelData[this.panelCounter - 1].pickType =
                pickElement.code;
              this.userData.panelData[this.panelCounter - 1].pickConfig =
                pickElement.range[0].pickConfig;
              this.userData.panelData[this.panelCounter - 1].totalNumbers =
                element.betGroup == "3Digit"
                  ? 3
                  : element.betGroup == "2Digit"
                  ? 2
                  : 1;
              this.panelNumberCounter = +this.gameData.maxPanelAllowed;
              this.userData.panelData[this.panelCounter - 1].pickedValues =
                Array(this.panelNumberCounter);
              this.postStateMsg = this.translate.instant(
                "dge." + betCode + "_" + pickCode + "_desc"
              );
            }
          });
        }
      });
      this.currentEnterNumIndex = 0;
      this.permInput = "";
      this.permClicked = false;
    }
    this.commonService.iframe_resize();
  }

  movePickFocus(event, dir, index) {
    if (event.srcElement.localName == "button") {
      if (
        dir == "RIGHT" &&
        event.srcElement.parentNode.nextElementSibling &&
        event.srcElement.parentNode.nextElementSibling.localName == "li"
      ) {
        event.srcElement.parentNode.nextElementSibling.focus();
      }
      if (
        dir == "LEFT" &&
        event.srcElement.parentNode.previousElementSibling &&
        event.srcElement.parentNode.previousElementSibling.localName == "li"
      ) {
        event.srcElement.parentNode.previousElementSibling.focus();
      }
    }
    if (event.srcElement.localName == "li") {
      if (
        dir == "RIGHT" &&
        event.srcElement.nextElementSibling &&
        event.srcElement.nextElementSibling.localName == "li"
      ) {
        event.srcElement.nextElementSibling.focus();
      }
      if (
        dir == "LEFT" &&
        event.srcElement.previousElementSibling &&
        event.srcElement.previousElementSibling.localName == "li"
      ) {
        event.srcElement.previousElementSibling.focus();
      }
    }
    this.commonService.iframe_resize();
  }

  selectPickedNum(num) {
    let suggestedNum = this.needSuggestion(num);
    if (suggestedNum) {
      this.alertService.info(
        this.translate.instant("dge.thai_num_disabled", {
          blocked: num,
          suggested: suggestedNum,
        })
      );
      return false;
    }
    let fullStatus = true;
    let numAlreadyIndex =
      this.userData.panelData[this.panelCounter - 1].pickedValues.indexOf(num);
    if (numAlreadyIndex > -1) {
      this.userData.panelData[this.panelCounter - 1].pickedValues[
        numAlreadyIndex
      ] = undefined;
    } else {
      if (
        this.userData.panelData[this.panelCounter - 1].pickedValues[
          this.currentEnterNumIndex
        ] == undefined ||
        this.userData.panelData[this.panelCounter - 1].pickedValues[
          this.currentEnterNumIndex
        ] == ""
      ) {
        this.userData.panelData[this.panelCounter - 1].pickedValues[
          this.currentEnterNumIndex
        ] = num;
        // document.getElementById('thaiLotto' + (this.currentEnterNumIndex + 1)).blur();
        fullStatus = false;
      } else {
        for (
          let i = 0;
          i <
          this.userData.panelData[this.panelCounter - 1].pickedValues.length;
          i++
        ) {
          if (
            this.userData.panelData[this.panelCounter - 1].pickedValues[i] ==
              undefined ||
            this.userData.panelData[this.panelCounter - 1].pickedValues[i] == ""
          ) {
            this.userData.panelData[this.panelCounter - 1].pickedValues[i] =
              num;
            fullStatus = false;
            break;
          }
        }
      }
      if (fullStatus == true) {
        this.alertService.error(
          this.translate.instant(
            this.panelNumberCounter > 1
              ? "dge.bet_nums_err"
              : "dge.bet_num_err",
            { panelNumber: this.panelNumberCounter }
          )
        );
      }
    }
    this.commonService.iframe_resize();
  }

  checkNumberSelected(num) {
    if (
      this.userData.panelData[this.panelCounter - 1].pickedValues.indexOf(num) >
        -1 ||
      (typeof this.userData.panelData[this.panelCounter - 1].pickedValues[0] !=
        "undefined" &&
        this.userData.panelData[this.panelCounter - 1].pickedValues[0].indexOf(
          num
        ) > -1) ||
      (typeof this.userData.panelData[this.panelCounter - 1].pickedValues[1] !=
        "undefined" &&
        this.userData.panelData[this.panelCounter - 1].pickedValues[1].indexOf(
          num
        ) > -1)
    ) {
      return true;
    }
    return false;
    this.commonService.iframe_resize();
  }

  selectBetAmount(j, betAmt) {
    // event.stopPropagation();
    this.showOtherAmountInput = false;
    this.otherAmtVal = "";
    if (this.gameData.betRespVOs[0].unitPrice <= 1) {
      this.userData.panelData[this.panelCounter - 1].betAmountMultiple =
        (j + 1) * 1;
    } else {
      this.userData.panelData[this.panelCounter - 1].betAmountMultiple = j + 1;
    }
    this.betError = "";
    this.otherNotice = "";
    this.commonService.iframe_resize();
  }

  /***********************For Other Bet Amt Modal Specific ***********************/

  // selectOtherAmount(event) {
  //   this.showOtherAmountInput = true;
  //   this.renderer.setElementClass(document.body, 'modal-open', true);
  //   this.betError = '';
  //   this.otherBetAmountMultiple = this.userData.panelData[this.panelCounter - 1].betAmountMultiple;
  //   if (this.betAmtArray.indexOf(this.userData.panelData[this.panelCounter - 1].betAmountMultiple) < 0) {
  //     this.otherAmtVal = '' + (this.userData.panelData[this.panelCounter - 1].betAmountMultiple * this.gameData.betRespVOs[0].unitPrice);
  //   } else {
  //     this.otherAmtVal = '';
  //   }
  //   setTimeout(() => {
  //     document.getElementById('otherAmt-' + this.panelCounter).focus();
  //     // event.srcElement.parentNode.children[1].focus();
  //   }, 500);
  //   this.commonService.iframe_resize();
  // }

  // selectOtherBetAmount(j, betAmt) {
  //   this.betError = '';
  //   this.otherBetAmountMultiple = (j + 1) * 10;
  //   this.otherAmtVal = '' + (this.otherBetAmountMultiple * this.gameData.betRespVOs[0].unitPrice);
  //   this.commonService.iframe_resize();
  // }

  // closeOtherAmountInput() {
  //   this.otherAmtVal = '';
  //   this.betError = '';
  //   this.otherBetAmountMultiple = 0;
  //   this.showOtherAmountInput = false;
  //   this.renderer.setElementClass(document.body, 'modal-open', false);
  //   this.commonService.iframe_resize();
  // }

  // continueOtherAmountInput() {
  //   if (this.otherAmtVal == '' && this.otherBetAmountMultiple <= 5) {
  //     this.betError = this.translate.instant('dge.beterr_cont');
  //   }
  //   if (this.betError == '') {
  //     this.otherAmtVal = '';
  //     this.betError = '';
  //     this.userData.panelData[this.panelCounter - 1].betAmountMultiple = this.otherBetAmountMultiple;
  //     this.otherBetAmountMultiple = 0;
  //     this.showOtherAmountInput = false;
  //     this.renderer.setElementClass(document.body, 'modal-open', false);
  //   }
  //   this.commonService.iframe_resize();
  // }

  /*********************************************************************************/
  /***************For Input Button specific || remove IT for modal *****************/

  selectOtherAmount(event) {
    if (!this.showOtherAmountInput) {
      this.showOtherAmountInput = true;
      this.otherNotice = this.translate.instant("dge.beterr_other_default", {
        mul: this.currCustom.transform(
          this.gameData.betRespVOs[0].unitPrice,
          "",
          "plain"
        ),
        max: this.currCustom.transform(
          "" +
            this.gameData.betRespVOs[0].maxBetAmtMul *
              this.gameData.betRespVOs[0].unitPrice,
          "",
          "plain"
        ),
      });
      this.betError = "";
      this.userData.panelData[this.panelCounter - 1].betAmountMultiple = 0;
      this.otherAmtVal = "";
      setTimeout(() => {
        document.getElementById("otherAmt-" + this.panelCounter).focus();
        this.commonService.iframe_resize();
        // event.srcElement.parentNode.children[1].focus();
      }, 500);
    }
    this.commonService.iframe_resize();
  }

  /*******************************************************************************/

  activateOtherAmt() {
    if (typeof this.userData != "undefined") {
      let index = this.betAmtArray.indexOf(
        this.userData.panelData[this.panelCounter - 1].betAmountMultiple *
          this.gameData.betRespVOs[0].unitPrice
      );
      if ((index > -1 && index > 5) || index < 0) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  onOtherAmtInputChange(event) {
    let regex = /[^0-9.]/g;
    const initalValue = this.otherAmtVal;
    this.otherAmtVal = initalValue.replace(regex, "");
    let formatVal = parseFloat(this.otherAmtVal).toFixed(1);
    if (formatVal == "NaN" && this.otherAmtVal == ".") {
      this.otherBetAmountMultiple = 0;
      this.otherAmtVal = "0.";
    } else if (formatVal == "NaN" && this.otherAmtVal == "") {
      this.otherBetAmountMultiple = 0;
    } else if (formatVal == "0.0" && this.otherAmtVal != "0.0") {
      this.otherBetAmountMultiple = 0;
      if (
        (this.otherAmtVal.match(/[.]/g) || []).length > 1 ||
        (this.otherAmtVal.match(/0/g) || []).length > 1
      ) {
        this.otherAmtVal = formatVal;
      }
    } else {
      let remainder =
        parseFloat(formatVal) %
        parseFloat(this.gameData.betRespVOs[0].unitPrice);
      if (remainder == 0 && formatVal != "0.0") {
        let quotient =
          parseFloat(formatVal) /
          parseFloat(this.gameData.betRespVOs[0].unitPrice);
        if (quotient <= this.gameData.betRespVOs[0].maxBetAmtMul) {
          // if (parseFloat(formatVal) <= this.gameData.betRespVOs[0].maxBetAmtMul) {
          this.otherBetAmountMultiple = quotient;
          if ((this.otherAmtVal.match(/[.]/g) || []).length > 1) {
            this.otherAmtVal = formatVal;
          } else if (
            this.otherAmtVal.indexOf(".") > -1 &&
            this.otherAmtVal.indexOf(".") != this.otherAmtVal.length - 1
          ) {
            this.otherAmtVal = formatVal;
          }
          this.betError = "";
          this.otherNotice = this.translate.instant(
            "dge.beterr_other_default",
            {
              mul: this.currCustom.transform(
                this.gameData.betRespVOs[0].unitPrice,
                "",
                "plain"
              ),
              max: this.currCustom.transform(
                "" +
                  this.gameData.betRespVOs[0].maxBetAmtMul *
                    this.gameData.betRespVOs[0].unitPrice,
                "",
                "plain"
              ),
            }
          );
        } else {
          this.betError = this.translate.instant("dge.beterr_amt_mul_max", {
            mul: this.gameData.betRespVOs[0].unitPrice,
            max:
              this.gameData.betRespVOs[0].unitPrice *
              this.gameData.betRespVOs[0].maxBetAmtMul,
          });
          // this.betError = this.translate.instant('dge.beterr_amt_mul_max', { mul: this.gameData.betRespVOs[0].unitPrice, max: this.gameData.betRespVOs[0].maxBetAmtMul });
          this.otherNotice = "";
          this.otherBetAmountMultiple = 0;
        }
      } else {
        this.betError = this.translate.instant("dge.beterr_amt_mul", {
          mul: this.gameData.betRespVOs[0].unitPrice,
        });
        this.otherNotice = "";
        this.otherBetAmountMultiple = 0;
      }
    }
    /*********************For Input Button specific || remove IT for modal **********************/
    this.userData.panelData[this.panelCounter - 1].betAmountMultiple =
      this.otherBetAmountMultiple;
    /********************************************************************************************/
    this.commonService.iframe_resize();
  }

  addMainPanel() {
    if (
      this.userInfo.sessid == "-" &&
      this.userInfo.playerid == "-" &&
      Constants.CLIENT_MULTI_CURRENCY[Constants.CLIENT_CODE]
    ) {
      this.commonService.openPlayerLogin();
      return false;
    }
    this.drawService.setPayoutPanelStatus(false);
    let pickedStatus = true;
    let counterUndefinedNo = 0;
    let counterUndefinedNoUP = 0;
    let counterUndefinedNoLP = 0;
    if (typeof this.userData.panelData[0] != "undefined") {
      if (!this.userData.panelData[0].pickType.startsWith("Banker")) {
        for (
          let j = 0;
          j < this.userData.panelData[0].pickedValues.length;
          j++
        ) {
          if (this.userData.panelData[0].pickedValues[j] == undefined) {
            ++counterUndefinedNo;
          }
        }
      }
      if (counterUndefinedNo > 0) {
        if (
          this.gameCode == Constants.THAI_LOTTERY ||
          this.gameCode == Constants.LOTTERY_DIAMOND ||
          this.gameCode == Constants.MYANMAR_2D
        ) {
          if (counterUndefinedNo == this.gameData.maxPanelAllowed) {
            pickedStatus = false;
          }
        }
      }
      if (!pickedStatus) {
        this.alertService.error(this.translate.instant("dge.num_sel_err"));
      }
      if (this.userData.panelData[0].betAmountMultiple == 0) {
        pickedStatus = false;
        this.alertService.error(this.translate.instant("dge.bet_amt_err"));
      }
      if (pickedStatus) {
        this.userData.panelData[0].pickedValues =
          this.userData.panelData[0].pickedValues.filter(function (el) {
            return el != null;
          });
        this.drawService.setPanelData(this.userData.panelData[0]);
        this.removeBetPanels();
        this.resetUserData();
        if (window.innerWidth >= Constants.TAB_WIDTH) {
          this.addMainbetPanel();
        }
      }
    }
    this.commonService.iframe_resize();
  }

  numberOfLines(purchasePanelIndex) {
    if (typeof this.userData != "undefined") {
      if (this.userData.panelData[purchasePanelIndex].betType != "") {
        let numberPickedLength = this.userData.panelData[
          purchasePanelIndex
        ].pickedValues.filter(function (el) {
          return el != null;
        }).length;
        if (numberPickedLength > 0) {
          this.changePostState(false);
          // this.postState = false;
          return numberPickedLength;
        } else {
          this.changePostState(true);
          // this.postState = true;
          return 0;
        }
      } else {
        this.changePostState(true);
        // this.postState = true;
        return 0;
      }
    }
    this.commonService.iframe_resize();
  }

  numberOfLines2(purchasePanelIndex) {
    if (typeof this.userData != "undefined") {
      if (this.userData.panelData[purchasePanelIndex].betType != "") {
        let numberPickedLength = this.userData.panelData[
          purchasePanelIndex
        ].pickedValues.filter(function (el) {
          return el != null;
        }).length;
        return numberPickedLength;
      } else {
        return 0;
      }
    }
    this.commonService.iframe_resize();
  }

  calculatePanelPrice(pIndex) {
    if (typeof this.userData != "undefined") {
      let unitPrice = 0;
      let betAmountMultiple = 0;
      if (this.userData.panelData[pIndex].betType != "") {
        unitPrice = this.betData[this.userData.panelData[pIndex].betType].unitPrice;
        betAmountMultiple = this.userData.panelData[pIndex].betAmountMultiple;
      }
      return unitPrice * betAmountMultiple * this.numberOfLines2(pIndex);
    } else {
      return 0;
    }
    this.commonService.iframe_resize();
  }

  updateClock() {
    if (this.diff_time.totalTime > -1 && this.diff_time.fetchRuleStatus) {
      let diff_day = Math.floor(this.diff_time.totalTime / (3600 * 24));
      let diff_hr = Math.floor((this.diff_time.totalTime % (3600 * 24)) / 3600);
      let diff_min = Math.floor((this.diff_time.totalTime % 3600) / 60);
      let diff_sec = Math.floor(this.diff_time.totalTime % 60);
      this.diff_time.shownTime[0] =
        diff_day > 9 ? "" + diff_day : "0" + diff_day;
      this.diff_time.shownTime[1] = diff_hr > 9 ? "" + diff_hr : "0" + diff_hr;
      this.diff_time.shownTime[2] =
        diff_min > 9 ? "" + diff_min : "0" + diff_min;
      this.diff_time.shownTime[3] =
        diff_sec > 9 ? "" + diff_sec : "0" + diff_sec;
      if (diff_day > 0) {
        // this.diff_time.convention = (diff_day == 1) ? 'day' : 'days';
        this.diff_time.convention = "day";
      } else if (diff_hr > 0) {
        // this.diff_time.convention = (diff_hr == 1) ? 'hr' : 'hrs';
        this.diff_time.convention = "hr";
      } else if (diff_min > 0) {
        // this.diff_time.convention = (diff_min == 1) ? 'min' : 'mins';
        this.diff_time.convention = "min";
      } else if (diff_sec > 0) {
        // this.diff_time.convention = (diff_sec == 1) ? 'sec' : 'secs';
        this.diff_time.convention = "sec";
      } else {
        this.diff_time.convention = "sec";
        ++this.tempCounter;
        if (this.fetchDataStatus || this.tempCounter == 1) {
          localStorage.removeItem(this.gameCode + "-drawGameData");
          this.drawService.getGameData(Constants.DRAW_ENGINE, this.gameCode);
          // this.notifyDrawMachineSubscription = this.commonService.notifyDrawMachine({ 'engine': Constants.DRAW_ENGINE, 'gameCode': this.gameCode }).subscribe((response: any) => {
          // });
          // this.drawService.setLoaderStatus(true);
        }
        this.fetchDataStatus = false;
      }
      --this.diff_time.totalTime;
    }
    if (this.diff_time.saleStartTime > 0) {
      this.saleTimerStatus = true;
      this.renderer.addClass(document.body, "modal-fix");
      let diff_day = Math.floor(this.diff_time.saleStartTime / (3600 * 24));
      let diff_hr = Math.floor(
        (this.diff_time.saleStartTime % (3600 * 24)) / 3600
      );
      let diff_min = Math.floor((this.diff_time.saleStartTime % 3600) / 60);
      let diff_sec = Math.floor(this.diff_time.saleStartTime % 60);
      this.diff_time.saleShownTime[0] =
        diff_day > 9 ? "" + diff_day : "0" + diff_day;
      this.diff_time.saleShownTime[1] =
        diff_hr > 9 ? "" + diff_hr : "0" + diff_hr;
      this.diff_time.saleShownTime[2] =
        diff_min > 9 ? "" + diff_min : "0" + diff_min;
      this.diff_time.saleShownTime[3] =
        diff_sec > 9 ? "" + diff_sec : "0" + diff_sec;
      if (diff_day > 0) {
        // this.diff_time.saleConvention = (diff_day == 1) ? 'day' : 'days';
        this.diff_time.convention = "day";
      } else if (diff_hr > 0) {
        // this.diff_time.saleConvention = (diff_hr == 1) ? 'hr' : 'hrs';
        this.diff_time.convention = "hr";
      } else if (diff_min > 0) {
        // this.diff_time.saleConvention = (diff_min == 1) ? 'min' : 'mins';
        this.diff_time.convention = "min";
      } else if (diff_sec > 0) {
        // this.diff_time.saleConvention = (diff_sec == 1) ? 'sec' : 'secs';
        this.diff_time.convention = "sec";
      } else {
        this.diff_time.saleConvention = "sec";
      }
      --this.diff_time.saleStartTime;
    } else {
      this.saleTimerStatus = false;
      if (this.activeDrawStatus) {
        this.renderer.removeClass(document.body, "modal-fix");
      }
    }
  }

  changePostState(val) {
    clearInterval(this.postStateInterval);
    this.postStateInterval = setInterval(() => {
      this.postState = val;
    }, 0);
  }

  loadBack() {
    if (this.loadLobby) {
      this.router.navigate(["/dge/lobby"]);
    } else {
      this.commonService.appLobbyBack();
      this.commonService.redirectParent("loadBackUrl");
    }
  }

  getBetName(betDispName) {
    if (betDispName != null) {
      let tempBetDispNameArray = betDispName.split("-");
      return tempBetDispNameArray[tempBetDispNameArray.length - 1];
    }
    return betDispName;
  }

  perm() {
    if (this.permInput == "") {
      this.alertService.error(this.translate.instant("dge.perm_err"));
      return false;
    }
    if (this.permInput.length > 1) {
      this.permClicked = true;
    }
  }

  fetchPlayerTicketList() {
    if (
      typeof this.userInfo == "undefined" ||
      this.userInfo.sessid == "-" ||
      this.gameData.drawRespVOs.length == 0
    ) {
      this.myTicketCount = 0;
      return false;
    }
    let temp = {
      gameCode: this.gameCode,
      orderBy: "asc",
      pageSize: 100,
      pageIndex: 0,
      drawId: this.gameData.drawRespVOs[0].drawId,
    };
    this.ticketListSubscription = this.drawService
      .fetchPlayerTicketList(temp)
      .subscribe((response: any) => {
        if (
          typeof response != "undefined" &&
          typeof response.data != "undefined" &&
          response.data.responseCode == 0 &&
          response.data.responseData.length > 0 &&
          response.data.responseData[0].ticketList != null
        ) {
          this.myTicketCount = response.data.responseData[0].ticketList.length;
        } else {
          this.myTicketCount = 0;
          // this.alertService.error(response.responseMessage);
        }
      });
  }

  navigateTicketList() {
    if (this.myTicketCount > 0) {
      this.router.navigate(["/dge/my-tickets"]);
    } else {
      return false;
    }
  }

  openDrawMachine() {
    // if (this.myTicketCount > 0) {
    //   this.router.navigate(['/dge/draw-machine'], {fragment: this.gameCode});
    // }else{
    return false;
    // }
  }

  openHelpModal(gameCode) {
    this.drawService.openHelpPopup(true, gameCode);
    this.commonService.iframe_resize();
  }
}



